import React, { useState, useEffect } from 'react';
import './affectation.css';
import Administration from './administration';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';
import { useNavigate, useParams } from 'react-router-dom';

function GestionLits({ onNext, onBack, patientId }) {
  const [roomsData, setRoomsData] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(patientId.roomId.roomNumber);
  const [selectedBed, setSelectedBed] = useState(patientId.bedNumber);
  const [confirmation, setConfirmation] = useState("");
  const [hospitals, setHospitals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [patientData, setPatientData] = useState(patientId);
  const [isEditing, setIsEditing] = useState(false);
  const { id } = useParams(); // Récupère l'ID du patient depuis l'URL si disponible
  const navigate = useNavigate();

  // Utilise l'ID du patient depuis les props ou l'URL
  const currentPatientId = patientId || id;

  const getUserIdFromToken = () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      return decodedToken.userId;
    }
    return null;
  };
  
  const userId = getUserIdFromToken();
  // Récupérer les hôpitaux
  useEffect(() => {
        console.log("paat",patientId)
    const fetchHospitals = async () => {
      if (!userId) return;
      
      setIsLoading(true);
      try {
        const response = await api.get(`/api/hospitals/admin/${userId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        if (response.status === 200) {
          setHospitals(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des hôpitaux:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHospitals();
  }, [userId]);

  // Récupérer les chambres une fois que les hôpitaux sont chargés
  useEffect(() => {
    const fetchRooms = async () => {
      if (hospitals.length === 0) return;
      
      setIsLoading(true);
      try {
        let allRooms = [];
        
        // Récupérer les chambres pour chaque hôpital
        for (const hospital of hospitals) {
          const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`);
          allRooms = allRooms.concat(roomsResponse.data);
        }
        
        // Stocker toutes les chambres
        setRoomsData(allRooms);
        
        // Si le patient a une chambre assignée, trouver son lit actuel
        if (patientData?.roomId.roomNumber) {
          const patientRoom = allRooms.find(room => room.roomNumber === patientData.roomId.roomNumber);
          if (patientRoom) {
            const patientBed = patientRoom.beds.find(bed => 
              bed.occupiedBy && bed.occupiedBy.toString() === currentPatientId
            );
            if (patientBed) {
              setSelectedBed(patientBed);
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des chambres de tous les hôpitaux:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchRooms();
  }, [hospitals, patientData]);

  const handleRoomSelect = (e) => {
    setSelectedRoom(e.target.value);
    setSelectedBed(null); // Réinitialiser le lit sélectionné quand on change de chambre
    setConfirmation("");
    setIsEditing(true);
  };

  const handleBedSelect = (bed) => {
    setSelectedBed(bed);
    setConfirmation("");
    setIsEditing(true);
  };

  const saveAssignment = async () => {
    if (!currentPatientId || !selectedRoom || !selectedBed) {
      setConfirmation("Veuillez sélectionner une chambre et un lit");
      return;
    }
    
    setIsLoading(true);
    try {
      // Récupérer l'ID de la chambre sélectionnée
      const selectedRoomData = roomsData.find(room => room.roomNumber === selectedRoom);
      if (!selectedRoomData) {
        throw new Error("Chambre non trouvée");
      }
      
      // Déterminer l'ID réel du patient
      const patientRealId = patientId?.patientId?._id || patientData?._id || currentPatientId;
      
      // Trouver l'ancien lit du patient pour le libérer si nécessaire
    //   if (patientData?.roomId.roomNumber && patientData.roomId.roomNumber !== selectedRoom) {
        const oldRoom = roomsData.find(room => room.roomNumber === patientData.roomId.roomNumber);
        if (oldRoom) {
            const oldBed = oldRoom.beds.find(bed => 
                bed.assignedPatient && (bed.assignedPatient === patientRealId || bed.assignedPatient.toString() === patientRealId)
            );
            
            console.log("pass",oldBed)
            if (oldBed) {
                // Libérer l'ancien lit seulement si on change de chambre ou de lit
                if (oldRoom.roomNumber !== selectedRoom || oldBed.bedNumber !== selectedBed.bedNumber) {
              await api.put(`/api/rooms/releasepatient/${oldRoom._id}`, 
                { bedNumber: oldBed.bedNumber },
                {
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                }
              );
            }
          }
        // }
      }
      
      // Attribuer le nouveau lit au patient
      await api.put(`/api/rooms/assignpatient`, {
        roomId: selectedRoomData._id,
        patientId: patientRealId,
        bedNumber: selectedBed.bedNumber
      });
            
      setConfirmation("Chambre et lit attribués avec succès");
      setIsEditing(false);
      
      // Mettre à jour le state local des chambres
      const updatedRooms = roomsData.map(room => {
        // Si c'est l'ancienne chambre du patient et qu'il a changé de chambre
        if (patientData?.roomId.roomNumber && room.roomNumber === patientData.roomId.roomNumber && room.roomNumber !== selectedRoom) {
          return {
            ...room,
            beds: room.beds.map(bed => {
              if (bed.occupiedBy && (bed.occupiedBy === patientRealId || bed.occupiedBy.toString() === patientRealId)) {
                return { ...bed, occupiedBy: null, isOccupied: false };
              }
              return bed;
            })
          };
        }
        // Si c'est la nouvelle chambre du patient
        else if (room.roomNumber === selectedRoom) {
          return {
            ...room,
            beds: room.beds.map(bed => {
              if (bed.bedNumber === selectedBed.bedNumber) {
                return { ...bed, occupiedBy: patientRealId, isOccupied: true };
              }
              return bed;
            })
          };
        }
        return room;
      });
      
      setRoomsData(updatedRooms);
      
      // Mettre à jour les données du patient localement
      setPatientData(prev => ({
        ...prev,
        roomNumber: selectedRoom
      }));
      
    } catch (error) {
      console.error('Erreur lors de l\'attribution du lit:', error);
      setConfirmation("Erreur lors de l'attribution du lit");
    } finally {
      setIsLoading(false);
    }
  };

  const currentRoom = roomsData.find(room => room.roomNumber === selectedRoom);
  
  // Fonction pour trouver le lit actuel du patient
  const getCurrentBed = () => {
    if (!patientData?.roomId.roomNumber) return null;
    
    const room = roomsData.find(r => r.roomNumber === patientData.roomId.roomNumber);
    if (!room) return null;
    
    return room.beds.find(bed => bed.occupiedBy && bed.occupiedBy.toString() === currentPatientId);
  };
  
  const currentBed = selectedBed || getCurrentBed();

  return (
    <div className="bed-assignment-container">
      <h3 className="bed-assignment-header">Affectation des lits</h3>
      
      {isLoading ? (
        <div className="bed-assignment-loading">
          <p>Chargement des données...</p>
        </div>
      ) : (
        <>
          {patientData && (
            <div className="bed-assignment-patient-info">
              <h4>Patient: {patientData.patientId.firstname} {patientData.patientId.lastname}</h4>
              {patientData.roomId.roomNumber && currentBed && !isEditing && (
                <div className="bed-assignment-current">
                  <p>Chambre actuelle: <strong>{patientData.roomId.roomNumber}</strong></p>
                  <p>Lit actuel: <strong>{currentBed.bedNumber ? currentBed.bedNumber : currentBed}</strong></p>
                  <button className="bed-assignment-modify-btn" onClick={() => setIsEditing(true)}>
                    Modifier l'affectation
                  </button>
                </div>
              )}
            </div>
          )}
          
          {(isEditing || !patientData?.roomId.roomNumber || !currentBed) && (
            <>
              <div className="bed-assignment-room-selection">
                <label className="bed-assignment-label">Sélectionner une chambre</label>
                <select 
                  value={selectedRoom} 
                  onChange={handleRoomSelect} 
                  className="bed-assignment-select"
                >
                  <option value="">-- Choisir --</option>
                  {roomsData.map((room, idx) => (
                    <option key={idx} value={room?.roomNumber}>{room?.roomNumber}</option>
                  ))}
                </select>
              </div>
              
              {selectedRoom && currentRoom && (
                <>
                  <h4 className="bed-assignment-room-title">
                    Sélectionner un lit dans la chambre {selectedRoom}
                  </h4>
                  <div className="bed-assignment-grid">
                    {currentRoom.beds.map(bed => (
                      <div 
                        key={bed._id} 
                        className={`bed-assignment-bed 
                          ${selectedBed?._id === bed._id ? 'bed-assignment-selected' : ''} 
                          ${(bed.isOccupied && (!bed.occupiedBy || bed.occupiedBy.toString() !== currentPatientId)) 
                            ? 'bed-assignment-occupied' 
                            : ''}`
                        }
                        onClick={() => {
                          if (!bed.isOccupied || (bed.occupiedBy && bed.occupiedBy.toString() === currentPatientId)) {
                            handleBedSelect(bed);
                          }
                        }}
                        style={{ 
                          cursor: (!bed.isOccupied || (bed.occupiedBy && bed.occupiedBy.toString() === currentPatientId)) 
                            ? 'pointer' 
                            : 'not-allowed'
                        }}
                      >
                        <p><strong>{bed.bedNumber}</strong></p>
                        <p>État: {
                          (bed.occupiedBy && bed.occupiedBy.toString() === currentPatientId)
                            ? '🟡 Affecté à ce patient'
                            : bed.isOccupied 
                              ? '🟥 Occupé' 
                              : '✅ Disponible'
                        }</p>
                        {selectedBed?._id === bed._id && (
                          <div className="bed-assignment-selected-indicator">✓ Sélectionné</div>
                        )}
                      </div>
                    ))}
                  </div>
                  
                  <div className="bed-assignment-actions">
                    <button 
                      className="bed-assignment-save-btn" 
                      onClick={saveAssignment} 
                      disabled={!selectedBed}
                    >
                      Enregistrer l'affectation
                    </button>
                    {isEditing && currentBed && (
                      <button 
                        className="bed-assignment-cancel-btn" 
                        onClick={() => {
                          setIsEditing(false);
                          setSelectedRoom(patientData?.roomId.roomNumber || "");
                          setSelectedBed(currentBed);
                        }}
                      >
                        Annuler
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
          
          {confirmation && (
            <p className={`bed-assignment-confirmation ${
              confirmation.includes("Erreur") 
                ? "bed-assignment-error" 
                : "bed-assignment-success"
            }`}>
              {confirmation}
            </p>
          )}
        </>
      )}
      
      <div className="bed-assignment-nav-buttons">
        {/* <button 
          className="bed-assignment-next-btn" 
          onClick={() => onNext(3)}
          disabled={!patientData?.roomId.roomNumber || !currentBed || isEditing}
        >
          Définir un plan de traitement
        </button> */}
        {onBack && (
          <button className="bed-assignment-back-btn" onClick={onBack}>
            Retour
          </button>
        )}
      </div>
    </div>
  );
}

export default GestionLits;